module.exports = __webpack_public_path__ + "static/media/JuanHelbert.95c8f30c.pdf";